import { render, staticRenderFns } from "./DocumentTemplates.vue?vue&type=template&id=78de4fce"
import script from "./DocumentTemplates.vue?vue&type=script&lang=js"
export * from "./DocumentTemplates.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplates.vue?vue&type=style&index=0&id=78de4fce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports